import axios from "axios"
import { fetchAccessToken } from "../utils/token"
import { BRIDGE_URL } from "../utils/constants"


// Hold appointment slot for booking
export const postHoldAppointment = async (body) => {

    try {

        const token = localStorage.getItem("oss-token")
        if(!token) fetchAccessToken()

        const formBody = {
            locationId: body?.location?.Id,
            serviceId: body?.testId,
            shiftId: body?.time?.shiftId,
            appointmentDate: body?.time?.appointmentDate,
            startTime: body?.time?.startTime,
            endTime: body?.time?.endTime,
            staffId: body?.staffId
        }

        const headers = {
            Authorization: `Bearer ${token}`
        }

        const res = await axios.post(`${BRIDGE_URL("services/apexrest/appointment/hold/")}`, formBody, { headers })

        return res;

    } catch (err) {

        return {
            error: true,
            message:
              err.response?.data?.message ||
              "Unfortunately the time slot you requested is no longer available. Please choose another.",
          };
    }

}
